<template>

<div class="port">

	<div class="port-back" v-on:click="$emit('back')"></div>

	<div class="port-name">{{ port.label }}</div>

	<div class="port-info">

		<div class="port-info-link" v-on:click="onAllClick">View all ports</div>

	</div>

	<template v-if="port.features.length">

		<div class="port-title">Capabilities</div>

		<div class="port-feature" v-for="(feature, index) in features" :key="'f' + index" :data-type="index" v-html="feature" />

	</template>

	<div class="port-title">Weekly Sailings</div>

	<div class="port-sailing" v-for="(route, index) in routes" :key="'s' + index">
	
		<div class="port-sailing-count">{{ route.sailings }}</div>
		<div class="port-sailing-name">{{ route.name }}</div>
		<div class="port-sailing-link" v-if="route.link" v-on:click.stop="onLinkClick(route.link)"></div>
	
	</div>

	<template v-if="contacts.length">

		<div class="port-title">Contact details</div>

		<div class="port-contact" v-for="(contact, index) in contacts" :key="'c' + index">
		
			<div class="port-contact-name">{{ contact.name }}</div>
			<div class="port-contact-address">{{ contact.address }}</div>
			<div class="port-contact-phone" v-if="contact.phone">{{ contact.phone }}</div>
		
		</div>

	</template>

</div>

</template>

<script>

export default {

	name: 'ComPort',

	computed: {

		port: function() {
		
			return this.$store.getters['locations/selected']
		
		},

		features: function() {
		
			var features = {}

			this.$_.each(this.port.features, function(id) {

				var text = this.$store.getters['features'][id]

				if(this.port.featuresText) {
				
					if(this.port.featuresText[id]) text = this.port.featuresText[id]
				
				}
			
				features[id] = text
			
			}.bind(this))

			return features
		
		},

		contacts: function() {
		
			return this.port.contacts || []

		},

		routes: function() {
		
			var routes = this.$_.filter(this.$store.getters['routes'], function(route) {
			
				return this.$_.contains(route.locations, this.port.id)
			
			}.bind(this))

			routes = this.$_.map(routes, function(route) {

				var otherLocation = this.$_.find(route.locations, function(id) {
				
					return id !== this.port.id && this.$store.getters['locations'][id].type === 'port'

				}.bind(this))
			
				return {
					sailings: route.sailings,
					name: this.$store.getters['locations'][otherLocation].label,
					link: route.link
				}
			
			}.bind(this))

			return this.$_.sortBy(routes, function(route) { 
			
				return route.name

			})
		
		}

	},

	methods: {

		onLinkClick: function(link) {
		
			this.$store.commit('pdf', link)
		
		},
	
		onAllClick: function() {
		
			this.$store.commit('ui/sidebar', 'ports')
		
		}
	
	}

}

</script>

<style scoped>

.port {
	padding: 0px 56px;
}

.port-back {
	width: 24px;
	height: 24px;
	position: absolute;
	right: 56px;
	top: -79px;
	cursor: pointer;
	background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAxCAMAAACrgNoQAAAAP1BMVEUAAAD///////////////////////////////////////////////////////////////////////////////9Du/pqAAAAFHRSTlMA8DBgENCgn5DgcL9ACgfAr4BQIN7oQdQAAADcSURBVEjHjdVJDoMwEETRMjYJkDnp+581KEL5y6peMfyHBJaMelsnZTNdapNaVcvE2NO6a61QjLl+4F0I33dJHWH7RUIE/UnKBH0m6ENBz2yIqJdOhzC9EfTzkBG2R6Q9Iu0RtmceCN+T7IKTld4IDjNBn4krfSaKPhT0fj6NPptnsQDJnKsQWY+I+1dDJH3XhIh6HeJs+u3fZ6LTI9IekfaItEeEPWJJeoS/7u9w1Qnfc9f2zJX3S3q+SNgjjg2O3gk2OHovLqxkIiR+YJG4aeH5gZgljaF0bkP6AvrWIZLqVnYrAAAAAElFTkSuQmCC');
	background-size: 24px 24px;
}

.port-name {
	color: #fff;
	font-weight: bold;
	font-size: 40px;
	border-bottom: 1px solid rgba(255, 255, 255, 0.25);
	padding-bottom: 15px;
}

.port-info {
	display: flex;
	justify-content: flex-end;
	padding-top: 15px;
}

.port-info-label {
	color: #fff;
	font-size: 12px;
	letter-spacing: 1.2px;
	font-weight: light;
	text-transform: uppercase;
	background-image: url('data:image/png;base64,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');
	background-repeat: no-repeat;
	background-position: 0px 50%;
	background-size: 21px auto;
	padding-left: 30px;
}

.port-info-link {
	color: #fff;
	font-size: 12px;
	cursor: pointer;
	letter-spacing: 1.2px;
	font-weight: light;
	text-transform: uppercase;
	border-bottom: 1px solid transparent;
	cursor: pointer;
}

.port-info-link:hover {
	border-bottom: 1px solid #fff;
}

.port-title {
	font-size: 12px;
	letter-spacing: 1.2px;
	text-transform: uppercase;
	border-bottom: 1px solid rgba(255, 255, 255, 0.25);
	color: #fff;
	font-weight: 300;
	padding-bottom: 10px;
	margin-top: 40px;
}

.port-feature {
	font-weight: 300;
	font-size: 18px;
	line-height: 20px;
	color: rgba(255, 255, 255, 0.85);
	padding: 23px 20px 23px 60px;
	border-bottom: 1px solid rgba(255, 255, 255, 0.25);
	background-position: 4px 50%;
	background-repeat: no-repeat;
}

.port-feature >>> b {
	font-weight: 700;
	color: #fff;
}

.port-feature[data-type="cargo"] {
	background-image: url(~@/assets/feature.cargo.png);
	background-size: 30px 31px;
	background-position: 10px 50%;
}

.port-feature[data-type="auto"] {
	background-image: url(~@/assets/feature.auto.png);
	background-size: 30px 25px;
	background-position: 10px 50%;
}

.port-feature[data-type="rail"] {
	background-image: url(~@/assets/feature.rail.png);
	background-size: 25px 35px;
	background-position: 12px 50%;
}

.port-feature[data-type="bulk"] {
	background-image: url(~@/assets/feature.bulk.png);
	background-size: 37px 37px;
	background-position: 7px 50%;
}

.port-feature[data-type="barge"] {
	background-image: url(~@/assets/feature.barge.png);
	background-size: 42px 34px;
	background-position: 4px 50%;
}

.port-feature[data-type="storage"] {
	background-image: url(~@/assets/feature.storage.png);
	background-size: 34px 35px;
	background-position: 8px 50%;
}

.port-sailing {
	padding: 10px 14px 10px 16px;
	border-bottom: 1px solid rgba(255, 255, 255, 0.25);
	background-position: 0px 50%;
	background-repeat: no-repeat;
	display: flex;
}

.port-sailing-count {
	background-color: #FDAA2A;
	color: #183353;
	font-size: 14px;
	font-weight: bold;
	text-align: center;
	width: 26px;
	height: 26px;
	line-height: 26px;
	border-radius: 50%;
	margin-right: 16px;
}

.port-sailing-name {
	font-size: 18px;
	color: #fff;
	font-weight: 300;
	line-height: 26px;
}

.port-sailing-link {
	width: 32px;
	height: 32px;
	cursor: pointer;
	right: 10px;
	top: 50%;
	margin-top: -16px;
	position: absolute;
	background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAuCAMAAABzsJvxAAAAZlBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+Vn2moAAAAIXRSTlMAwD+LCtqA0CO3EPAwYLDgoJBsRfbs08gspgZ3WUc6IRad6wkPAAAA30lEQVQ4y83Uyw7CIBCFYVoVlEqv3u/n/V9SSyQD7WQaN6b/ggTyLRgWKGUbg3FV6VSc9YjLbCPW9AfZoMq7InIGCDtKA9okDjCKY7lNHJDxTJETGTmZkZMZOZmRI5ZTtWfBVTZiGlE9I+ciVqasyb/pXhCzmmqQRiytFhnl6ixUABfP5DJgGbHXOu3JshuGXTl2HrEjx+x5v4nblSeGcc2GdXuk7RzHSgw7cOx0BFbUR91nMymTNEIIpvv1QeTnnc2k/2XVNLv0S5tLOaBQqsV02n8+cuHyj3Yh1XYf8wa7u0Pw4zAIKwAAAABJRU5ErkJggg==');
	background-position: 100% 50%;
	background-repeat: no-repeat;
	background-size: 19px 23px;
}

.port-contact {
	margin-top: 20px;
	font-size: 16px;
	line-height: 20px;
	color: #fff;
}

.port-contact-name {
	font-weight: bold;
}

</style>
